import { Icons } from '@agro-club/agroclub-shared'
import { FC } from 'react'
import styled from 'styled-components'
import { AButton } from 'views/components/Analytics'

const DeleteButton = styled(AButton)`
  width: 40px;
  height: 40px;
  padding: 6px 8px;
  svg {
    width: 20px;
    height: 20px;
  }
`

export const BinButton: FC<Partial<{ title: string; onClick: () => void }>> = (props) => {
  return <DeleteButton id="delete" color="secondary" background="none" Icon={Icons.IconDelete} {...props} />
}
